// Wire format for the URL-hash routine share. Versioned so a future
// `v: 2` can extend the payload without breaking older receivers.
//
// Notes:
// - `ids` are dropped on encode and regenerated on import — the receiving
//   family generates fresh `uid()` values.
// - `sortIndex` is reassigned on import from the receiving profile's
//   `nextRoutineSortIndex` (and contiguous indexes for the tasks).
// - No progress, profile metadata, or sync code travels with the link.

export interface SharedRoutineV1 {
  v: 1;
  routine: {
    name: string;
    emoji: string;
    tasks: Array<{ name: string; emoji: string; tag: string | null }>;
  };
}

export class ShareDecodeError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ShareDecodeError';
  }
}

export class ShareTooLargeError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ShareTooLargeError';
  }
}
